import { encode } from "js-base64";
import { makeObservable, observable } from "mobx";
import Cookies from "js-cookie";
import { post, get } from "../services/request";
import {
  SSO_LOGIN,
  SSO_REGISTER_PHONE,
  SSO_SUBSYSTEM_REDIRECT,
  SEND_MSG,
  SSO_LOGIN_PHONE,
  SSO_LOGIN_DINGDING,
  GET_USER_INFO,
  GET_USER_INFO_BY_ACCOUNT,
  SSO_LOGIN_DING_CONTAINER,
} from "../services/request/urls";
import { message } from "antd";
import { Header } from "antd/lib/layout/layout";
import dd from "dingtalk-jsapi";
const systemKey = window.CONFIG.systemKey;
const tokenKey = `${systemKey}-token`;
const accountKey = `${systemKey}-account`;
const orAdminKey = `${systemKey}-orAdmin`;

class AuthStore {
  ssoIsLogin = !!localStorage.getItem(tokenKey);

  account = localStorage.getItem(accountKey);
  orAdmin = localStorage.getItem(orAdminKey);
  isIntimePeriod: boolean = true;
  safeCode: string = "";

  constructor() {
    makeObservable(this, {
      ssoIsLogin: observable,
      account: observable,
      orAdmin: observable,
      isIntimePeriod: observable,
      safeCode: observable,
    });
  }

  async ssoLogin(account: string, password: string, appkey?: string) {
    account = account.trim();
    password = password.trim();

    const res = await post(SSO_LOGIN, {
      a: encode(account),
      b: encode(password),
      c: encode(this.safeCode),
    });
    if (res?.code !== 1) {
      message.error(res?.message);
      return false;
    }

    localStorage.setItem(accountKey, account);
    localStorage.setItem(tokenKey, res.data);
    this.account = account;
    this.ssoIsLogin = true;

    if (appkey) {
      this.linkToSubsystem(appkey);
    }

    return true;
  }
  async ssoLoginMobile(phone: string, code: string, appkey?: string) {
    phone = phone.trim();
    code = code.trim();

    const res = await post(SSO_LOGIN_PHONE, {
      a: encode(phone),
      b: encode(code),
    });
    if (res?.code !== 1) {
      message.error(res?.message);
      return false;
    }

    localStorage.setItem(accountKey, phone);
    localStorage.setItem(tokenKey, res.data);
    this.account = phone;
    this.ssoIsLogin = true;

    if (appkey) {
      this.linkToSubsystem(appkey);
    }

    return true;
  }

  async linkToSubsystem(appkey: string) {
    const res = await get(
      SSO_SUBSYSTEM_REDIRECT + "?appKey=" + appkey + "&token=" + localStorage.getItem(tokenKey),
      null
    );
    if (res?.code !== 1) {
      message.error(res?.message ?? "跳转失败");
      return;
    }
    window.open(res.data, "blank");

    // const url = `${SSO_SUBSYSTEM_REDIRECT}?appKey=${appkey}&token=${localStorage.getItem(
    //   tokenKey
    // )}`;
    // window.open(url, "blank");
  }

  async register(phone: string, code: string, password: string) {
    code = code.trim();
    password = password.trim();
    phone = phone.trim();
    const res = await post(SSO_REGISTER_PHONE, { phone, code, password });
    if (res?.code !== 1) {
      message.error(res?.message ?? "注册失败");
      return;
    }
    message.success("注册成功");
    const res1 = await post(SSO_LOGIN, { account: phone, password });
    if (res1?.code !== 1) {
      message.error(res1?.message);
      return false;
    }

    localStorage.setItem(accountKey, phone);
    localStorage.setItem(tokenKey, res1.data);
    this.account = phone;
    this.ssoIsLogin = true;
    document.location.href = "/user/cards";
  }

  async logout() {
    this.ssoIsLogin = false;
    localStorage.removeItem(tokenKey);
    localStorage.removeItem(accountKey);
    localStorage.removeItem(orAdminKey);
    document.location.href = "/sso/login";
  }

  async clearLocalStorage() {
    this.ssoIsLogin = false;
    localStorage.removeItem(tokenKey);
    localStorage.removeItem(accountKey);
  }

  async sendMsg(phone: string, repData: string) {
    const res = await post(SEND_MSG, { phone, repData });
    console.log(res, "res");
    if (res?.code !== 1) {
      this.isIntimePeriod = false;
      if (res?.data === "false") {
        message.error(res?.message ?? "校验失效，请重新校验");
        return;
      }
      message.error(res?.message ?? "发送失败");
      return;
    }

    this.isIntimePeriod = true;
    message.success("发送成功");
  }

  async ssoLoginDingDing(code: string) {
    code = code.trim();

    const res = await get(SSO_LOGIN_DINGDING + "?code=" + code, null);
    if (res?.code !== 1) {
      message.error(res?.message ?? "获取失败");
      return;
    }
    message.success("获取成功");
  }

  async ssoLoginDingContainer() {
    return new Promise((resolve, reject) => {
      dd.getAuthCode({
        corpId: "ding3e5118c30f7916b5bc961a6cb783455b",
        success: (res: any) => {
          const { code } = res;
          console.log("获取授权码", code, res);
          post(SSO_LOGIN_DING_CONTAINER, { code: code }).then((res: any) => {
            if (res?.code !== 1) {
              message.error("登录失败");
              reject("登录失败");
              return;
            }
            localStorage.setItem(accountKey, res.data.account);
            localStorage.setItem(tokenKey, res.data.token);
            resolve(null);
          });
        },
        fail: () => {
          message.error("工作台登录失败");
          reject("工作台登录失败");
        },
        complete: () => {
          console.log("工作台登录 complete");
        },
      });
    });
  }

  async getUserInfo(token: string) {
    const res = await get(GET_USER_INFO + "?token=" + token, null);
    if (res?.code !== 1) {
      message.error(res?.message ?? "获取个人信息失败");
      document.location.href = "/sso/login";
      return;
    }
    localStorage.setItem(accountKey, res.data?.account);
    localStorage.setItem(tokenKey, token);
    localStorage.setItem(orAdminKey, res.data?.orAdmin);
    this.account = res.data?.account;
    this.ssoIsLogin = true;
    this.orAdmin = res.data?.orAdmin;
    document.location.href = "/user/cards";
    console.log(res, "res");
  }

  async getUserInfoByAccount(account: string) {
    const res = await get(
      GET_USER_INFO_BY_ACCOUNT + "?account=" + account,
      {
        header: { token: localStorage.getItem(tokenKey) },
      },
      true
    );
    if (res?.code !== 1) {
      message.error(res?.message ?? "获取个人信息失败");
      document.location.href = "/sso/login";
      return;
    }
    localStorage.setItem(accountKey, res.data?.account);
    localStorage.setItem(orAdminKey, res.data?.orAdmin);
    this.account = res.data?.account;
    this.ssoIsLogin = true;
    this.orAdmin = res.data?.orAdmin;
    document.location.href = "/user/cards";
  }

  setSafeCode(code: string) {
    this.safeCode = code;
  }
  setIsIntimePeriod(state: boolean) {
    this.isIntimePeriod = state;
  }
  setAccount(account: string) {
    this.account = account;
  }
  setIsLogin(state: boolean) {
    this.ssoIsLogin = state;
  }
  setOrAdmin(state: string) {
    this.orAdmin = state;
  }

  checkToken() {}
}

export default new AuthStore();
